__turbopack_context__.v({
  "check": "MVnHwG_check",
  "dot": "MVnHwG_dot",
});
